export default "__VITE_ASSET__NTmmS50l__"